// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gewM","field":"styles_field__3YKO-","fieldCol":"styles_fieldCol__3yuhM","diffCol":"styles_diffCol__8h4Kp","diff":"styles_diff__vc591"};